import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const ChatFooter = ({ socket }) => {
    const [message, setMessage] = useState('');
    const { name, _id, } = useSelector((state) => ({
        name: state?.Auth?.userInfo?.name,
        _id: state?.Auth?.userInfo?._id,
    }));
    const handleSendMessage = (e) => {
        e.preventDefault();
        if (message.trim()) {
            const id = `${socket.id}${Math.random()}`;
            socket.emit('message', {
                text: [{ text: message, user: { _id, name: name }, _id: id }],
                name: name,
                teacherId: _id,
                id,
                socketID: socket.id,
            });
        }
        setMessage('');
    };

    return (
        <div className="chat__footer">
            <form className="form d-flex Justify-content-between" onSubmit={handleSendMessage}>
                <input
                    type="text"
                    placeholder="Write message"
                    className="message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                />
                <button className="btn btn-success sendBtn" id="myBtn">
                    SEND
                </button>
            </form>
        </div>
    );
};

export default ChatFooter;